export class BancoConta {
  ContaCodigoBanco = null;
  ContaAgencia = null;
  ContaAgenciaDV = null;
  ContaNumero = null;
  ContaNumeroDV = null;
  ContaTipo = null;
  ContaCodigoBeneficiario = null;
  ContaCodigoBancoCorrespondente = null;
  ContaCodigoEmpresa = null;

  constructor(conta) {
    this.ContaCodigoBanco = conta.codigoBancario;
    this.ContaAgencia = conta.agencia;
    this.ContaAgenciaDV = conta.digitoAgencia;
    this.ContaNumero = conta.conta;
    this.ContaNumeroDV = conta.digitoConta;
    this.ContaTipo = conta.contaBancariaTipo;
    this.ContaCodigoBeneficiario = conta.codigoBeneficiario;
    this.ContaCodigoBancoCorrespondente = conta.codigoBancoCorrespondente;
    this.ContaCodigoEmpresa = conta.codigoEmpresa;
  }
}
